/**
 * ****************************************************************************
 * @description     :   Store data and process common will use in app
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

import messages, { MSG_TYPE, MSG_TITLE } from '@/utils/messages';
import repository from '@/repository';
import helpers from '@/utils/helpers';

export default {
    namespaced: true,
    state: {
        isLoading: false,
        isForceLoading: false,
        isNoLoading: false,
        countLoading: 0,
        isShowHeaderError: false,
        headerErrors: [],
        isShowModalMessage: false,
        isShowPtjModalMessage: false,
        S9007: [],
        modalMessage: {
            // type: MSG_TYPE.ERROR,
            type: MSG_TYPE.SUCCESS,
            title: '',
            content: '',
            okText: 'はい',
            cancelText: 'いいえ',
            customText: '初期化',
            showBtnCancelWarning: false,
            callback: () => {},
            callbackCancel: () => {},
            callbackCustom: () => {}
        },
        ptjModalMessage: {
            // type: MSG_TYPE.ERROR,
            type: MSG_TYPE.SUCCESS,
            title: '',
            content: '',
            okText: 'はい',
            cancelText: 'いいえ',
            customText: '初期化',
            showBtnCancelWarning: false,
            callback: () => {},
            callbackCancel: () => {},
            callbackCustom: () => {}
        },
        header: {
            title: '',
            showBack: false,
            isDisabledBack: false,
            isShowReload: false,
            fixBc: false,
            topButtons: [],
            topMessage: false,
            progressBar: {
                display: false,
                stepCurrent: 0,
                stepTotal: 0
            },
            onBack: () => {
                helpers.func_back();
            }
        },
        footer: {
            footerButtons: []
        },
        footerModals: [],
        isExistsLeftMenu: false,
        isShowLeftMenu: localStorage.getItem('isPinIconLeftMenu') === 'true' ? true : false,
        screenId: 'login',
        isDataScreenChange: false,
        isLogout: false,
        isLogin: false,
        user: {},
        menus: [],
        screenAuthority: 0,
        isBacking: false,
        notification: [],
        countNotify: 0,
        showSideBar: true,
        isReportLinkMenu: false,
        urlASP: '',
        zoom: 100,
        order_number: 0,
        isFaqLayout: false,
        // Global Wrapper State
        globalWrapper: {
            visible: false,
            component: null,
            componentProps: {},
            triggerElement: null,
            onClose: null,
            onSelect: null
        },
        // Global Popup State - Stack Support
        popupStack: [],
        popup: {
            isVisible: false,
            component: null,
            componentProps: {},
            title: '',
            logoSrc: '',
            dimensions: {
                width: '75%',
                height: '90%',
                maxWidth: null,
                maxHeight: null
            },
            styles: {
                overlay: {},
                wrapper: {},
                header: {},
                logo: {},
                title: {},
                body: {},
                footer: {},
                closeButton: {}
            },
            classes: {
                overlay: '',
                wrapper: '',
                header: '',
                logo: '',
                title: '',
                body: '',
                footer: '',
                closeButton: ''
            },
            options: {
                showHeader: true,
                showLogo: false,
                showCloseButton: true,
                showFooter: false,
                closeOnOverlay: true,
                closeOnEscape: true,
                pureContent: false
            },
            onClose: null,
            onSelect: null,
            eventHandlers: {}
        },
        // Global Widget State
        widget: {
            isVisible: false,
            showContent: false,
            component: null,
            componentProps: {},
            position: 'bottom-right',
            isMobile: false,
            iconElement: null,
            iconProps: {},
            showCloseButton: true,
            showIconToggle: false,
            styles: {
                container: {},
                icon: {},
                content: {},
                closeButton: {}
            },
            classes: {
                container: '',
                icon: '',
                content: '',
                closeButton: ''
            },
            offset: {
                x: 20,
                y: 20
            },
            onClose: null,
            onIconClick: null
        },
        isScroll: false,
        // Navigation State - Route props without URL change
        routeProps: {}
    },
    getters: {
        getRouteProps: (state) => (routeName) => {
            return state.routeProps[routeName] || {};
        },

        hasRouteProps: (state) => (routeName) => {
            return !!state.routeProps[routeName] && Object.keys(state.routeProps[routeName]).length > 0;
        }
    },
    mutations: {
        showLoading(state) {
            state.isLoading = true;
        },
        hideLoading(state) {
            state.isLoading = false;
        },
        showForceLoading(state) {
            state.isForceLoading = true;
        },
        hideForceLoading(state) {
            state.isForceLoading = false;
        },
        showHeaderError(state, errors) {
            state.isShowHeaderError = true;
            state.headerErrors = errors;
        },
        hideHeaderError(state) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
        },
        showModalMessage(state, message) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            state.isShowModalMessage = true;
            if (message) {
                if (message.type) {
                    state.modalMessage.type = message.type;
                } else {
                    // state.modalMessage.type = MSG_TYPE.ERROR;
                    state.modalMessage.type = MSG_TYPE.SUCCESS;
                }
                state.modalMessage.title = message.title;
                if (message.content) {
                    state.modalMessage.content = message.content;
                } else {
                    state.modalMessage.content = messages.E999;
                }
                if (message.okText) {
                    state.modalMessage.okText = message.okText;
                } else {
                    state.modalMessage.okText = 'はい';
                }
                if (message.cancelText) {
                    state.modalMessage.cancelText = message.cancelText;
                } else {
                    state.modalMessage.cancelText = 'いいえ';
                }
                if (message.customText) {
                    state.modalMessage.customText = message.customText;
                } else {
                    state.modalMessage.customText = '初期化';
                }
                state.modalMessage.showBtnCancelWarning = message.showBtnCancelWarning;
                state.modalMessage.callback = message.callback;
                state.modalMessage.callbackCancel = message.callbackCancel;
                state.modalMessage.callbackCustom = message.callbackCustom;
            } else {
                state.modalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E999,
                    content: messages.E999,
                    okText: 'はい',
                    cancelText: 'いいえ',
                    showBtnCancelWarning: false,
                    callback: () => {},
                    callbackCancel: () => {},
                    callbackCustom: () => {}
                };
            }
        },
        updateShowModalMessage(state, value) {
            state.isShowModalMessage = value;
        },
        hideModalMessage(state) {
            state.isShowModalMessage = false;
        },
        showPtjModalMessage(state, message) {
            state.isShowHeaderError = false;
            state.headerErrors = [];
            state.isShowPtjModalMessage = true;
            if (message) {
                if (message.type) {
                    state.ptjModalMessage.type = message.type;
                } else {
                    // state.modalMessage.type = MSG_TYPE.ERROR;
                    state.ptjModalMessage.type = MSG_TYPE.SUCCESS;
                }
                state.ptjModalMessage.title = message.title;
                if (message.content) {
                    state.ptjModalMessage.content = message.content;
                } else {
                    state.ptjModalMessage.content = messages.E999;
                }
                if (message.okText) {
                    state.ptjModalMessage.okText = message.okText;
                } else {
                    state.ptjModalMessage.okText = 'はい';
                }
                if (message.cancelText) {
                    state.ptjModalMessage.cancelText = message.cancelText;
                } else {
                    state.ptjModalMessage.cancelText = 'いいえ';
                }
                if (message.customText) {
                    state.ptjModalMessage.customText = message.customText;
                } else {
                    state.ptjModalMessage.customText = '初期化';
                }
                state.ptjModalMessage.showBtnCancelWarning = message.showBtnCancelWarning;
                state.ptjModalMessage.callback = message.callback;
                state.ptjModalMessage.callbackCancel = message.callbackCancel;
                state.ptjModalMessage.callbackCustom = message.callbackCustom;
            } else {
                state.ptjModalMessage = {
                    type: MSG_TYPE.ERROR,
                    title: MSG_TITLE.E999,
                    content: messages.E999,
                    okText: 'はい',
                    cancelText: 'いいえ',
                    showBtnCancelWarning: false,
                    callback: () => {},
                    callbackCancel: () => {},
                    callbackCustom: () => {}
                };
            }
        },
        updateShowPtjModalMessage(state, value) {
            state.isShowPtjModalMessage = value;
        },
        hidePtjModalMessage(state) {
            state.isShowPtjModalMessage = false;
        },
        setHeader(state, header) {
            if (header === null || header === undefined || header === '' || (Array.isArray(header) && header.length === 0)) {
                state.header = {
                    title: '',
                    showBack: false,
                    isDisabledBack: false,
                    isShowReload: false,
                    fixBc: false,
                    topButtons: [],
                    progressBar: {
                        display: false,
                        stepCurrent: 0,
                        stepTotal: 0
                    },
                    onBack: () => {
                        helpers.func_back();
                    }
                };
            } else if (typeof header === 'object' && Object.keys(header).length > 0) {
                state.header = {
                    ...state.header,
                    ...header
                };

                // if (header.onBack) {
                //     let newOnBack = (e) => {
                //         e.preventDefault();
                //         if (e.which === 1) {
                //             header.onBack();
                //         }
                //     };

                //     state.header.onBack = newOnBack;
                // }
            }
        },
        setFooterFunction(state, footer) {
            if (footer.footerButtons && footer.footerButtons.length > 0) {
                for (let i = 0; i < footer.footerButtons.length; i++) {
                    if (!footer.footerButtons[i].isDisabled) footer.footerButtons[i].isDisabled = false;
                }
            }
            state.footer.footerButtons = footer.footerButtons;
        },
        setFooterModals(state, footerModals) {
            state.footerModals = footerModals.footerModals;
        },
        setZoom(state, val) {
            state.zoom = val;
        },
        setShowLeftMenu(state, status) {
            state.isShowLeftMenu = status;
        },
        setExistsLeftMenu(state, status) {
            state.isExistsLeftMenu = status;
        },
        setAppState(state, data) {
            state.menus = data.menus;
            state.user = data.user;
        },
        resetAppState(state) {
            state.menus = [];
            state.user = {};
        },
        setScreenId(state, id) {
            state.screenId = id;
        },
        setNoLoading(state, val) {
            state.isNoLoading = val;
        },
        increaseCountLoading(state) {
            state.countLoading += 1;
        },
        decreaseCountLoading(state) {
            state.countLoading -= 1;
            if (state.countLoading < 0) {
                state.countLoading = 0;
            }
        },
        setOpenSideBarState(state, flag) {
            state.showSideBar = flag;
        },
        setDataScreenChange(state, data) {
            state.isDataScreenChange = data;
        },
        setLogout(state, data) {
            state.isLogout = data;
        },
        setLogin(state, data) {
            state.isLogin = data;
        },
        setScreenAuthority(state, data) {
            state.screenAuthority = data;
        },
        setBacking(state, data) {
            state.isBacking = data;
        },
        setNotification(state, data) {
            if (data.notify && data.notify.length > 0) {
                state.notification = data?.notify ?? [];
                state.countNotify = data?.notify[0]?.total_cnt ?? 0;
            } else {
                state.countNotify = 0;
            }
            // const lengthNotify = data.notify.length;
            // if (lengthNotify < 10) {
            //     for (let i = 0; i < 10 - lengthNotify; i++) {
            //         state.notification.push({
            //             notification_id: i,
            //             show_content: '',
            //             period_from: null,
            //             period_to: null
            //         });
            //     }
            // }
        },
        setIsReportLinkMenu(state, data) {
            state.isReportLinkMenu = data;
        },
        setUrlASP(state, data) {
            state.urlASP = data;
        },
        setMessageS9007(state, data) {
            state.S9007 = data;
        },
        setUserInfo(state, data) {
            state.user = data;
        },
        resetUserInfo(state) {
            state.user = {};
        },
        setOrderNumber(state, data) {
            state.order_number = data;
        },
        setIsFaqLayout(state, value) {
            state.isFaqLayout = value;
        },
        // Global Wrapper Mutations
        showGlobalWrapper(state, payload) {
            state.globalWrapper.visible = true;
            state.globalWrapper.component = payload.component;
            state.globalWrapper.componentProps = payload.componentProps || {};
            state.globalWrapper.triggerElement = payload.triggerElement || null;
            state.globalWrapper.onClose = payload.onClose || null;
            state.globalWrapper.onSelect = payload.onSelect || null;
        },
        hideGlobalWrapper(state) {
            state.globalWrapper.visible = false;
            state.globalWrapper.component = null;
            state.globalWrapper.componentProps = {};
            state.globalWrapper.triggerElement = null;
            state.globalWrapper.onClose = null;
            state.globalWrapper.onSelect = null;
        },
        // Popup Mutations
        showPopup(state, payload) {
            // If there's already a popup visible, push current to stack
            if (state.popup.isVisible) {
                state.popupStack.push({
                    isVisible: state.popup.isVisible,
                    component: state.popup.component,
                    componentProps: state.popup.componentProps,
                    title: state.popup.title,
                    logoSrc: state.popup.logoSrc,
                    dimensions: { ...state.popup.dimensions },
                    styles: { ...state.popup.styles },
                    classes: { ...state.popup.classes },
                    options: { ...state.popup.options },
                    onClose: state.popup.onClose,
                    onSelect: state.popup.onSelect,
                    eventHandlers: { ...state.popup.eventHandlers }
                });
            }

            // Show new popup
            state.popup.isVisible = true;
            state.popup.component = payload.component;
            state.popup.componentProps = payload.componentProps || {};
            state.popup.title = payload.title || '';
            state.popup.logoSrc = payload.logoSrc || '';
            state.popup.dimensions = {
                ...state.popup.dimensions,
                ...(payload.dimensions || {})
            };
            state.popup.styles = {
                ...state.popup.styles,
                ...(payload.styles || {})
            };
            state.popup.classes = {
                ...state.popup.classes,
                ...(payload.classes || {})
            };
            state.popup.options = {
                ...state.popup.options,
                ...(payload.options || {})
            };
            state.popup.onClose = payload.onClose || null;
            state.popup.onSelect = payload.onSelect || null;
            state.popup.eventHandlers = payload.eventHandlers || {};
        },
        hidePopup(state) {
            if (state.popup.onClose && typeof state.popup.onClose === 'function') {
                state.popup.onClose();
            }

            // If there are popups in stack, restore the previous one
            if (state.popupStack.length > 0) {
                const previousPopup = state.popupStack.pop();
                state.popup.isVisible = previousPopup.isVisible;
                state.popup.component = previousPopup.component;
                state.popup.componentProps = previousPopup.componentProps;
                state.popup.title = previousPopup.title;
                state.popup.logoSrc = previousPopup.logoSrc;
                state.popup.dimensions = previousPopup.dimensions;
                state.popup.styles = previousPopup.styles;
                state.popup.classes = previousPopup.classes;
                state.popup.options = previousPopup.options;
                state.popup.onClose = previousPopup.onClose;
                state.popup.onSelect = previousPopup.onSelect;
            } else {
                // No more popups in stack, hide completely
                state.popup.isVisible = false;
                state.popup.component = null;
                state.popup.componentProps = {};
                state.popup.title = '';
                state.popup.logoSrc = '';
                state.popup.onClose = null;
                state.popup.onSelect = null;
                // Reset to defaults
                state.popup.dimensions = {
                    width: '75%',
                    height: '90%',
                    maxWidth: null,
                    maxHeight: null
                };
                state.popup.styles = {
                    overlay: {},
                    wrapper: {},
                    header: {},
                    logo: {},
                    title: {},
                    body: {},
                    footer: {},
                    closeButton: {}
                };
                state.popup.classes = {
                    overlay: '',
                    wrapper: '',
                    header: '',
                    logo: '',
                    title: '',
                    body: '',
                    footer: '',
                    closeButton: ''
                };
                state.popup.options = {
                    showHeader: true,
                    showLogo: false,
                    showCloseButton: true,
                    showFooter: false,
                    closeOnOverlay: true,
                    closeOnEscape: true,
                    pureContent: false
                };
            }
        },
        hideAllPopups(state) {
            // Clear all popups including stack
            state.popupStack = [];
            state.popup.isVisible = false;
            state.popup.component = null;
            state.popup.componentProps = {};
            state.popup.title = '';
            state.popup.logoSrc = '';
            state.popup.onClose = null;
            state.popup.onSelect = null;
            // Reset to defaults
            state.popup.dimensions = {
                width: '75%',
                height: '90%',
                maxWidth: null,
                maxHeight: null
            };
            state.popup.styles = {
                overlay: {},
                wrapper: {},
                header: {},
                logo: {},
                title: {},
                body: {},
                footer: {},
                closeButton: {}
            };
            state.popup.classes = {
                overlay: '',
                wrapper: '',
                header: '',
                logo: '',
                title: '',
                body: '',
                footer: '',
                closeButton: ''
            };
            state.popup.options = {
                showHeader: true,
                showLogo: false,
                showCloseButton: true,
                showFooter: false,
                closeOnOverlay: true,
                closeOnEscape: true,
                pureContent: false
            };
        },
        updatePopupConfig(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(state.popup, key)) {
                    state.popup[key] = { ...state.popup[key], ...payload[key] };
                }
            });
        },
        // Widget Mutations
        showWidget(state, payload) {
            state.widget.isVisible = true;
            state.widget.component = payload.component;
            state.widget.componentProps = payload.componentProps || {};
            state.widget.position = payload.position || 'bottom-right';
            state.widget.isMobile = payload.isMobile || false;
            state.widget.iconElement = payload.iconElement || null;
            state.widget.iconProps = payload.iconProps || {};
            state.widget.showCloseButton = payload.showCloseButton !== undefined ? payload.showCloseButton : true;
            state.widget.showIconToggle = payload.showIconToggle !== undefined ? payload.showIconToggle : false;
            state.widget.styles = {
                ...state.widget.styles,
                ...(payload.styles || {})
            };
            state.widget.classes = {
                ...state.widget.classes,
                ...(payload.classes || {})
            };
            state.widget.offset = {
                ...state.widget.offset,
                ...(payload.offset || {})
            };
            state.widget.onClose = payload.onClose || null;
            state.widget.onIconClick = payload.onIconClick || null;
            state.widget.draggable = payload.draggable || false;
        },
        hideWidget(state) {
            if (state.widget.onClose && typeof state.widget.onClose === 'function') {
                state.widget.onClose();
            }
            state.widget.isVisible = false;
            state.widget.showContent = false;
            state.widget.component = null;
            state.widget.componentProps = {};
            state.widget.onClose = null;
            state.widget.onIconClick = null;
            // Reset to defaults
            state.widget.position = 'bottom-right';
            state.widget.isMobile = false;
            state.widget.iconElement = null;
            state.widget.iconProps = {};
            state.widget.showCloseButton = true;
            state.widget.showIconToggle = false;
            state.widget.styles = {
                container: {},
                icon: {},
                content: {},
                closeButton: {}
            };
            state.widget.classes = {
                container: '',
                icon: '',
                content: '',
                closeButton: ''
            };
            state.widget.offset = {
                x: 20,
                y: 20
            };
            state.widget.draggable = false;
        },
        toggleWidgetContent(state, show = null) {
            if (show !== null) {
                state.widget.showContent = show;
            } else {
                state.widget.showContent = !state.widget.showContent;
            }
        },
        updateWidgetConfig(state, payload) {
            Object.keys(payload).forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(state.widget, key)) {
                    if (typeof state.widget[key] === 'object' && state.widget[key] !== null) {
                        state.widget[key] = {
                            ...state.widget[key],
                            ...payload[key]
                        };
                    } else {
                        state.widget[key] = payload[key];
                    }
                }
            });
        },
        setIsScroll(state, value) {
            state.isScroll = value;
        },
        // Route Props Mutations
        setRouteProps(state, { routeName, props }) {
            state.routeProps[routeName] = { ...props };
        },
        clearRouteProps(state, routeName) {
            delete state.routeProps[routeName];
        },
        clearAllRouteProps(state) {
            state.routeProps = {};
        },
        updateRouteProp(state, { routeName, key, value }) {
            if (!state.routeProps[routeName]) {
                state.routeProps[routeName] = {};
            }
            state.routeProps[routeName][key] = value;
        }
    },
    actions: {
        setOpenSideBar(context, isMobile) {
            context.commit('setOpenSideBarState', isMobile);
        },
        setScreenId(context, screenid) {
            try {
                if (screenid) {
                    context.commit('setScreenId', screenid);
                    // repository.checkScreenAuthority(screenid).then((res) => {
                    //     const { data } = res;
                    //     if (data.Code === 200) {
                    //         if (data.Data.screenauthority == 0) {
                    //             Router.push({ name: 'Bs002000i' });
                    //         } else {
                    //             context.commit(
                    //                 'setScreenAuthority',
                    //                 data.Data.screenauthority
                    //             );
                    //         }
                    //     }
                    // });
                }
            } catch (e) {
                console.log('Action setScreenId: ' + e.message);
            }
        },
        getNotify(context, { code }) {
            try {
                repository.getNotify(code).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setNotification', data.Data ?? {});
                    }
                });
            } catch (e) {
                console.log('Action setNotification: ' + e.message);
            }
        },
        saveNotify(context, { code }) {
            try {
                repository.saveNotify(code).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (data.Data[0].statusCode === '0') {
                            context.commit('setNotification', {});
                        }
                    }
                });
            } catch (e) {
                console.log('Action saveNotification: ' + e.message);
            }
        },
        updatePassWord(context, input) {
            try {
                repository.changePassWord(input.data).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        if (data.Data[0].statusCode === '0') {
                            // context.commit('setNotification', {});
                            this.commit('app/showModalMessage', {
                                title: MSG_TITLE.S059,
                                content: messages.E163,
                                okText: 'OK'
                            });
                            input.callback(0);
                        }
                    } else if (data.Code == 423) {
                        input.callback(1);
                    }
                });
            } catch (e) {
                console.log('Action savePassword: ' + e.message);
            }
        },
        /**
         * postCommonHeader
         * -----------------------------------------
         * @author : hainn - 2024/11/26 - create
         * @params :
         * @access : private
         */
        postCommonHeader(context, input) {
            try {
                repository.postCommonHeader(input).then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        context.commit('setOrderNumber', data.Data.order_number);
                    } else if (data.Code === 422) {
                        if (input?.onErrorValidate) {
                            input?.onErrorValidate(data.Message[0]);
                        }
                    } else {
                        if (input?.onError) {
                            input?.onError(data.Data.message);
                        }
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        },
        /**
         * getNotificationMessage
         * -----------------------------------------
         * @author : phuongdt - 2025/04/04 - create
         * @params :
         * @access : private
         */
        getNotificationMessage() {
            try {
                repository.getNotificationMessage().then((res) => {
                    const { data } = res;
                    if (data.Code === 200) {
                        const listMessage = res.data.Data;
                        listMessage.map((message) => {
                            helpers.notificationApi(message);
                        });
                    }
                });
            } catch (e) {
                console.log('Action get data screen: ' + e.message);
            }
        }
    }
};
